import { LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';

export type IconSize = 'xs' | 'sm' | 'default' | 'lg' | 'xl' | 'xxl';

/**
 * A base element.
 */
export abstract class PdsIcon extends LitElement {
  /**
   * ICON SIZE
   * xs - 12x12
   * sm - 16x16
   * default - 20x20
   * lg - 24x24
   * xl - 32x32
   * xxl - 40x40
   */
  getSize(size: IconSize): Number {
    switch (size) {
      case 'xs':
        return 12;
      case 'sm':
        return 16;
      case 'lg':
        return 24;
      case 'xl':
        return 32;
      case 'xxl':
        return 40;
      default:
        return 20;
    }
  }

  @property({ type: String })
  size: IconSize = 'default';

  @state()
  icon: SVGElement;

  abstract createIconElement(): SVGElement;

  setIconAttributes() {
    this.icon = this.createIconElement();
    this.icon.setAttribute('height', this.getSize(this.size).toString());
    this.icon.setAttribute('width', this.getSize(this.size).toString());
    this.icon.setAttribute('aria-hidden', 'true');
    this.icon.setAttribute('display', 'block');
  }

  connectedCallback() {
    super.connectedCallback();
    this.setIconAttributes();
  }

  attributeChangedCallback(
    name: string,
    oldVal: string | null,
    newValue: string | null,
  ) {
    super.attributeChangedCallback(name, oldVal, newValue);
    this.setIconAttributes();
  }
}
